import {Controller} from '@hotwired/stimulus';

export default class NavScrollController extends Controller {
  static targets = ['nav'];

  connect() {
    this.lastScrollPosition = window.scrollY;
    this.handleScroll = this.handleScroll.bind(this); // Bind the method for proper context
    window.addEventListener('scroll', this.handleScroll);
  }

  disconnect() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    var currentScrollPosition = window.scrollY;
    var scrollDirection = currentScrollPosition > this.lastScrollPosition ? 'down' : 'up';
    var position = ((window.innerHeight + Math.round(window.scrollY)) + 30  >= document.body.offsetHeight)

    if (scrollDirection === 'down') {
      this.element.classList.add('hidden')
    } else if (!position) {
      this.element.classList.remove('hidden')
    }

    this.lastScrollPosition = currentScrollPosition;
  }
}
